import React from 'react';
import { readConfObject, } from '@jbrowse/core/configuration';
import { observer } from 'mobx-react';
import { stripAlpha } from '@jbrowse/core/util';
import { useTheme } from '@mui/material';
// locals
import Arrow from './Arrow';
const Segments = observer(function (props) {
    const { feature, featureLayout, selected, config, 
    // some subfeatures may be computed e.g. makeUTRs,
    // so these are passed as a prop, or feature.get('subfeatures') by default
    subfeatures = feature.get('subfeatures'), } = props;
    const theme = useTheme();
    const c = readConfObject(config, 'color2', { feature });
    const color2 = c === '#f0f' ? stripAlpha(theme.palette.text.secondary) : c;
    const { left = 0, top = 0, width = 0, height = 0 } = featureLayout.absolute;
    const y = top + height / 2;
    return (React.createElement(React.Fragment, null,
        React.createElement("line", { "data-testid": feature.id(), x1: left, y1: y, y2: y, x2: left + width, stroke: color2 }), subfeatures === null || subfeatures === void 0 ? void 0 :
        subfeatures.map(subfeature => {
            const subfeatureId = String(subfeature.id());
            const subfeatureLayout = featureLayout.getSubRecord(subfeatureId);
            // This subfeature got filtered out
            if (!subfeatureLayout) {
                return null;
            }
            const { GlyphComponent } = subfeatureLayout.data || {};
            return (React.createElement(GlyphComponent, { key: `glyph-${subfeatureId}`, ...props, feature: subfeature, topLevel: false, featureLayout: subfeatureLayout, selected: selected }));
        }),
        React.createElement(Arrow, { ...props })));
});
export default Segments;
